import type { ChainProgress } from "@scenix/core";

import { timecode } from "./scrub";

/**
 * What a project says about how far along it is wherever it is listed rather
 * than opened (ADR 000067).
 *
 * The same two numbers and the same words the project page uses, so a card and
 * the page it links to cannot appear to disagree. This is the reading that
 * replaced the declared stage, which nothing maintains and nothing shows.
 */
export function chainLabel(chain: ChainProgress): string {
  if (chain.plannedSec <= 0) return "nothing planned";
  if (chain.madeSec <= 0) return `${timecode(chain.plannedSec)} planned`;
  return `${timecode(chain.madeSec)} of ${timecode(chain.plannedSec)} made`;
}

/**
 * Whether every planned second has a picture, which is the state worth
 * noticing across a list of projects.
 *
 * At least, rather than exactly: a made segment routinely comes out a shade
 * longer than the brief budgeted, and a chain that overruns its plan is finished
 * rather than 103% finished (ADR 000025).
 */
export function chainComplete(chain: ChainProgress): boolean {
  return chain.plannedSec > 0 && chain.madeSec >= chain.plannedSec;
}
